/**
 * Program 12.1 UX3 — EPC commercial context stored in opportunities.epc_context_json / epc_tenders.epc_context_json
 */
export type EpcStakeholderRole =
  | 'END_USER'
  | 'CLIENT'
  | 'PMC'
  | 'CONSULTANT'
  | 'PROCUREMENT'
  | 'TECHNICAL_CONTACT'
  | 'COMMERCIAL_CONTACT'
  | 'DECISION_MAKER';

export type EpcStakeholderEntry = {
  role: EpcStakeholderRole;
  name?: string;
  contact_id?: string;
  customer_id?: string;
  relationship?: string;
  notes?: string;
};

export type EpcValueConfidence = 'ROUGH' | 'INDICATIVE' | 'CUSTOMER_BUDGET' | 'TENDER_VALUE' | 'VALIDATED';

export type EpcQualificationDimension = {
  key: string;
  label: string;
  rating?: string;
  notes?: string;
};

export type EpcOpportunityContext = {
  end_user?: string;
  project_title?: string;
  scope_summary?: string;
  key_deliverables?: string;
  site_location?: string;
  execution_model?: string;
  expected_duration?: string;
  major_constraints?: string;
  capability_fit?: string[];
  value_confidence?: EpcValueConfidence;
  expected_tender_date?: string;
  expected_award_date?: string;
  strategic_fit?: string;
  relationship_strength?: string;
  competition_level?: string;
  stakeholders?: EpcStakeholderEntry[];
  qualification?: EpcQualificationDimension[];
  data_quality_notes?: string;
};

export function parseEpcContext(raw: unknown): EpcOpportunityContext {
  if (!raw || typeof raw !== 'object') return {};
  return raw as EpcOpportunityContext;
}

export function mergeEpcContext(
  base: EpcOpportunityContext,
  patch: Partial<EpcOpportunityContext>
): EpcOpportunityContext {
  return { ...base, ...patch };
}

export function weightedPipeline(value: number | null | undefined, probability: number | null | undefined): number | null {
  if (value == null || probability == null) return null;
  const v = Number(value);
  const p = Number(probability);
  if (!Number.isFinite(v) || !Number.isFinite(p)) return null;
  return (v * p) / 100;
}
